<template>
  <body id="mainBody" style="opacity: 0">
    <div id="app">
      <router-view/>
    </div>
  </body>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>

    function setRem(){
      // console.log('123');
			//这里自己定义px转rem的转换规则
			//在改变窗口大小或者加载完成之后所有的尺寸都已转变后执行下面这一句，把body的透明度设为1
			document.getElementById('mainBody').style.opacity = '1'   // ******
		}
		// 改变窗口大小时重新设置 rem
		window.onresize = function () {
		   setRem()
		}
		// 加载完成
		window.onload = function () {
			setRem()
		}
</script>